"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GradeAndFeedbackTime = void 0;
var _react = require("react");
var _hooks = require("../../../../../../../hooks");
var _Select = require("../../../../../../../UI/Select");
var _TaskManager = require("../../../../../TaskManager.provider");
var _SectionLabel = require("../../../SectionLabel");
var _GradeAndFeedbackTime = _interopRequireDefault(require("./GradeAndFeedbackTime.styles"));
var _GradeAndFeedbackCustomTime = require("../GradeAndFeedbackCustomTime");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const GradeAndFeedbackTime = props => {
  const {
    task,
    setTask,
    setIsChanged,
    getLabel,
    language
  } = (0, _react.useContext)(_TaskManager.TaskManagerContext);
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const styles = (0, _GradeAndFeedbackTime.default)();
  const gradeTimeOptions = (0, _react.useMemo)(() => [{
    value: 'immediate',
    label: getLabel('show_feedback_immediate')
  }, {
    value: 'afterSubmitByAll',
    label: getLabel('show_feedback_afterSubmitByAll')
  }, {
    value: 'afterTeacherComment',
    label: getLabel('show_feedback_afterTeacherComment')
  }], [getLabel]);
  const defaultGradeTimeOption = gradeTimeOptions[task.taskType === 'exam' ? 2 : 0];
  const [selectedOption, setSelectedOption] = (0, _react.useState)({
    value: task.feedbackType,
    label: getLabel(`show_feedback_${task.feedbackType}`)
  });
  const handleSelectOption = option => {
    if (task && !task?.isReadOnly) {
      setSelectedOption(option);
      setIsChanged(true);
      setTask({
        ...task,
        feedbackType: option.value
      });
    }
  };
  (0, _react.useEffect)(() => {
    const selectOption = gradeTimeOptions.find(gradeTimeOption => gradeTimeOption.value === task.feedbackType) || defaultGradeTimeOption;
    setSelectedOption(selectOption);
  }, [defaultGradeTimeOption, gradeTimeOptions, task.feedbackType]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-TaskManager__grade-and-feedback-time'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionLabel.SectionLabel, {
        isDisabled: task?.isReadOnly,
        text: getLabel('text_label_whenShowScore')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.Select, {
        value: selectedOption,
        onChange: handleSelectOption,
        anchorWidth: isMobileView ? 'auto' : 'fit-content',
        btnProps: {
          color: 'basic',
          view: 'outlined',
          customStyle: {
            width: isMobileView ? '100%' : pxToRem(language === 'en' ? 238 : 220)
          },
          shape: isMobileView ? 'roundedRectangle' : 'ellipse',
          isDisabled: task?.isReadOnly
        },
        options: gradeTimeOptions
      })]
    }), task.feedbackType === 'afterTeacherComment' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_GradeAndFeedbackCustomTime.GradeAndFeedbackCustomTime, {
      ...props
    })]
  });
};
exports.GradeAndFeedbackTime = GradeAndFeedbackTime;